const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}
function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}
const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;

  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, JSON.parse(JSON.stringify(requestDefaultConfigs)))
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const d = document.createElement('div');
        d.innerHTML = html;
        sectionCache.set(url, d);
        resolve(d);
        // const div = <div />
        // div.innerHTML = html
        // sectionCache.set(url, div)
        // resolve(div)
      })
      .catch(reject);
  });
}

class MCartAddons extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      zipCode: '[name="address[zip]"]',
      province: '[name="address[province]"]',
      country: '[name="address[country]"]',
      addressForm: '[data-address="root"]',
      shippingMessage: ".m-cart-addon__shipping-rate",
      cartDiscountCode: '[name="discount"]',
      cartDiscountCodeNoti: "[data-discount-noti]",
      cartNote: '[name="note"]',
      saveAddonButton: ".m-cart-addon--save",
      closeAddonButton: ".m-cart-addon--close",
      calcShippingButton: ".m-cart-addon--calculate",
      triggerAddonButton: ".m-cart-addon--trigger-button",
      devliveryTime: '[name="attributes[Delivery time]"]',
    };

    this.cartWrapper = document.querySelector(".m-cart-drawer");
    this.isCartPage = this.dataset.template === "cart";
    console.log("Is cart page:", this.isCartPage);


    if (this.isCartPage) { 
      this.cartWrapper = document.querySelector(".m-cart__footer--wrapper");
    }

    this.initAddress = false;
    this.cartOverlay = this.cartWrapper?.querySelector(".m-cart__overlay");
    console.log("Cart overlay:", this.cartOverlay);

    this.domNodes = queryDomNodes(this.selectors, this);
    console.log("DOM nodes found:", this.domNodes);

    this.rootUrl = window.Shopify.routes.root;
    this.discountCodeKey = "minimog-discount-code";
    this.deliveryCodeKey = "minimog-delivery-code";

    this.init();
  }

  init() {
    console.log("Initializing MCartAddons");
    const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;

    addEventDelegate({
      selector: this.selectors.triggerAddonButton,
      context: this,
      handler: (e, addonButton) => {
        e.preventDefault();
        console.log("Addon trigger clicked:", addonButton);

        if (this.isCartPage) {
          const addonCurrentActive = document.querySelector(".m-cart-addon__body.open");
          if (addonCurrentActive) {
            console.log("Closing previously open addon");
            addonCurrentActive.classList.remove("open");
          }
        }

        const { open: addonTarget } = addonButton.dataset;
        console.log("Opening addon target:", addonTarget);

        const addonNode = this.cartWrapper.querySelector(`#m-addons-${addonTarget}`);
        console.log("Addon node found:", addonNode);

        this.removeActiveAllButton();
        addonButton.classList.add("active");
        addonNode?.classList.add("open");
        this.cartOverlay?.classList.add("open");

        this.openAddon = addonNode;

        if (addonTarget === "shipping") {
          console.log("Fetching shipping country options...");
          fetchSection("country-options", { url: window.location.origin + Shopify.routes.root })
            .then((html) => {
              console.log("Country options fetched:", html);
              const select = html.querySelector("#AddressCountry");
              const options = select?.querySelectorAll("option");
              const defaultSelect = addonNode.querySelector("#MadrressCountry select");
              options?.forEach((option) => defaultSelect?.appendChild(option));
              this.setupCountries();
              defaultSelect.value = defaultSelect?.dataset.default;
            })
            .catch((err) => console.error("Shipping fetch error:", err));
        }
      },
    });

    addEventDelegate({
      selector: this.selectors.closeAddonButton,
      context: this.cartWrapper,
      handler: (e) => {
        console.log("Closing addon");
        this.close(e);
      },
    });

    addEventDelegate({
      selector: this.selectors.calcShippingButton,
      context: this.cartWrapper,
      handler: (e) => {
        console.log("Calculating shipping");
        this.calcShipping(e);
      },
    });

    if (cartDiscountCode) {
      const code = localStorage.getItem(this.discountCodeKey);
      console.log("Loaded discount code from storage:", code);
      if (code) {
        cartDiscountCode.value = code;
        if (cartDiscountCodeNoti) {
          cartDiscountCodeNoti.style.display = "inline";
        }
      }
    }

    if (devliveryTime) {
      const code = localStorage.getItem(this.deliveryCodeKey);
      console.log("Loaded delivery code from storage:", code);
      if (code) devliveryTime.value = code;
    }

    this.saveAddonValue();

    const today = new Date().toISOString().slice(0, 16);
    const deliveryTimeElm = this.querySelector("#delivery-time");
    if (deliveryTimeElm) deliveryTimeElm.min = today;
  }

  removeActiveAllButton() {
    console.log("Removing active class from all addon buttons");
    const triggerButtons = this.querySelectorAll(this.selectors.triggerAddonButton);
    triggerButtons?.forEach((button) => button.classList.remove("active"));
  }

  setupCountries() {
    if (this.initAddress) return;
    console.log("Initializing Shopify country/province selector");
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
        hideElement: "AddressProvinceContainer", 
      });
      this.initAddress = true;
    }
  }


  close(event) {
    event.preventDefault();
    console.log("Closing addon:", this.openAddon);
    this.openAddon?.classList.remove("open");
    this.cartOverlay?.classList.remove("open");
    this.removeActiveAllButton();
    this.openAddon = null;
  }

  calcShipping(event) {
    event.preventDefault();
    console.log("calcShipping called");
    const actionsWrapper = event.target.closest(".m-cart-addon__action");
    actionsWrapper.classList.add("m-spinner-loading");

    const zipCode = this.domNodes.zipCode?.value.trim();
    const country = this.domNodes.country?.value;
    const province = this.domNodes.province?.value;
    console.log("Shipping info:", { zipCode, country, province });

    this.domNodes.shippingMessage.classList.remove("error");
    this.domNodes.shippingMessage.innerHTML = "";

    const showDeliveryDays = actionsWrapper.dataset.showDeliveryDays === "true";

    fetch(
      `${this.rootUrl}cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`
    )
      .then((res) => res.json())
      .then((res) => {
        console.log("Shipping rates response:", res);
        actionsWrapper.classList.remove("m-spinner-loading");
        if (res?.shipping_rates?.length > 0) {
          res.shipping_rates.forEach((rate) => {
            console.log("Shipping rate:", rate);
          });
        } else {
          console.warn("No shipping rates found or error in response");
        }
      })
      .catch((err) => console.error("Shipping fetch error:", err));
  }

  saveAddonValue() {
    console.log("Setting up saveAddonValue events");
    addEventDelegate({
      event: "click",
      context: this.cartWrapper,
      selector: this.selectors.saveAddonButton,
      handler: (event, target) => {
        console.log("Save addon button clicked:", target.dataset.action);
        event.preventDefault();
        const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;

        if (target.dataset.action === "coupon" && cartDiscountCode) {
          const code = cartDiscountCode.value;
          console.log("Saving coupon code:", code);
          localStorage.setItem(this.discountCodeKey, code);
          if (cartDiscountCodeNoti) {
            cartDiscountCodeNoti.style.display = code ? "inline" : "none";
          }
          this.close(event);
        }

        if (target.dataset.action === "note") {
          console.log("Updating cart note:", cartDiscountCode?.value);
          this.updateCartNote();
          this.close(event);
        }

        if (target.dataset.action === "delivery") {
          const code = devliveryTime.value;
          const isValidDate = Date.parse(code);
          console.log("Saving delivery time:", code, "Valid:", isValidDate > Date.now());
          if (isValidDate > Date.now()) {
            localStorage.setItem(this.deliveryCodeKey, code);
            this.close(event);
          } else {
            localStorage.setItem(this.deliveryCodeKey, "");
            devliveryTime.value = "";
            console.warn("Invalid delivery date:", code);
          }
        }
      },
    });
  }
  // updateCartNote() {
  //   const cartNoteValue = this.domNodes.cartNote.value;
  //   console.log("Sending cart note to server:", cartNoteValue);
  //   const body = JSON.stringify({ note: cartNoteValue });
  //   fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  // }
  updateCartNote() {
    const cartNoteElement = this.domNodes.cartNote;

    if (!cartNoteElement) {
      console.error("Cart note element not found!");
      return;
    }

    const cartNoteValue = cartNoteElement.value;
    console.log("Sending cart note to server:", cartNoteValue);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: cartNoteValue
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log("Cart updated successfully:", data);
    })
    .catch(err => {
      console.error("Cart update failed:", err);
    });
  }
}

customElements.define("m-cart-addons", MCartAddons);

document.body.addEventListener("click", function (event) { 

  const overlay = document.querySelector(".m-cart__overlay");

  const closeAllAddons = () => {
    document
      .querySelectorAll(".m-cart-addon__body.open")
      .forEach(el => {
        el.style.height = "0px";
        el.classList.remove("open");
      });

    overlay?.classList.remove("open");
  };

  const openButton = event.target.closest("[data-open]");
  if (openButton) {
    event.preventDefault();

    const addonName = openButton.dataset.open;
    const addonEl = document.getElementById(`m-addons-${addonName}`);

    if (addonEl) {
      closeAllAddons();

      addonEl.classList.add("open");

      const contentHeight = addonEl.scrollHeight;
      addonEl.style.height = contentHeight + "px";

      overlay?.classList.add("open");
    }
    return;
  }

  const closeBtn = event.target.closest(
    ".m-cart-addon--close, .m-cart-addon--save"
  );

  if (closeBtn) {
    event.preventDefault();
    closeAllAddons();
    return;
  }

  if (event.target.closest(".m-cart__overlay")) {
    event.preventDefault();
    closeAllAddons();
  }
});